module.exports = __webpack_public_path__ + "static/media/card-blog4.2f0b75db.jpg";